import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG imports
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';

import { LoaderComponent } from './loader/loader.component';
import { AuthDialogsComponent } from './auth-dialogs/auth-dialogs.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    ToastModule,
  ],
  declarations: [LoaderComponent, AuthDialogsComponent],
  exports: [LoaderComponent, AuthDialogsComponent],
})
export class SharedModule {}
